import http from './httpClient';

const CommunicationMS = {
  sendIssue(data: Record<string, unknown>) {
    return http.post(`${import.meta.env.VITE_COMMUNICATION_V0_BASE}/issue/send`, data);
  },
};

export default CommunicationMS;
